
import { Component, Prop, Vue } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import QuestionText from "./QuestionText.vue";
import AdminOptions from "./AdminOptions.vue";
import { SurveyQuestion } from "@/model/SurveyQuestion";
import { SurveyQuestionOptions } from "@/model/SurveyQuestionOptions";
import utils from "@/stuff/Utils";
import { ResponseStatus } from "@/model/Enums";

@Component({ components: { QuestionText, AdminOptions } })
export default class Money extends Vue {    

    @Prop({ required: true })
    question!: SurveyQuestion;

    @Prop({ default: SurveyQuestionOptions.CreateDefault })
    options!: SurveyQuestionOptions;

    errorMessage = "";

    mask = { 
        precision: 0,
        decimal: '.',
        thousands: ','
    }

    get tooltipTargetID(): string {
        return "tooltipTarget-" + this.question.id;
    }

    get isReadOnly(): boolean {
        return this.options.isReadOnly || this.question.supplierResponses.status == ResponseStatus.Accepted
    }

    get numberText(): string {
        return String(this.question.supplierResponses.numberResponse);
    }
    set numberText(value: string) {
        value = value.replaceAll(",", "");
        this.question.supplierResponses.numberResponse = utils.hasNumericValue(value) ? +value : null;
    }

    get currencyCode(): string {
        if (utils.isEmptyOrWhitespace(this.question.supplierResponses.currencyCode)) {
            this.question.supplierResponses.currencyCode = "GBP";
        }

        return this.question.supplierResponses.currencyCode!;
    }
    set currencyCode(value: string) {
        this.question.supplierResponses.currencyCode = value;
    }

    @Validations()
    validations() {
        return {
            responseText: { 
                isValid: () => true
            }
        };
    }
}
